import styled from "styled-components";

import { Page } from "@formant/ui/component/common/Page";

import { Header } from "../Header";
import { TabButtons } from "./TabButtons";
import { TabContent } from "./TabContent";

export const PageHeader = styled(Header)`
    grid-area: header;
`;

export const PageNav = styled.div`
    grid-area: page-nav;
    overflow-y: auto;
`;

export const MobileNav = styled.div`
    grid-area: mobile-nav;
`;

export const ContentArea = styled(TabContent)`
    grid-area: content;
`;

export const TabPage = styled(Page)`
    display: grid;
    grid-template-columns: 15rem 1fr;
    grid-template-rows: max-content 1fr;

    grid-template-areas:
        "header content"
        "page-nav content";

    ${MobileNav} {
        display: none;
    }

    ${PageNav} {
        display: block;
    }

    /* TODO propagate literal into theme */
    @media (max-width: 30rem) {
        grid-template-columns: 1fr;
        grid-template-rows: max-content min-content 1fr;

        grid-template-areas:
            "header"
            "mobile-nav"
            "content";

        ${MobileNav} {
            display: flex;
            overflow-x: auto;
            > * {
                flex: 1;
            }
        }

        ${PageNav} {
            display: none;
        }
    }
`;

export const PageTabButtons = styled(TabButtons)`
    margin-left: 1.875rem;
`;
